import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import publicService from '../services/publicService';
import './BookingPage.css'; // Um novo CSS para esta página

const BookingPage = () => {
  const { userId } = useParams();
  const [passo, setPasso] = useState(1); // 1: serviço, 2: data/hora, 3: dados, 4: sucesso
  const [servicos, setServicos] = useState([]);
  const [servicoSelecionado, setServicoSelecionado] = useState(null);
  const [dataSelecionada, setDataSelecionada] = useState('');
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [horarioSelecionado, setHorarioSelecionado] = useState('');
  const [dadosCliente, setDadosCliente] = useState({ nome: '', telefone: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServicos = async () => {
      try {
        const data = await publicService.getServicosByUserId(userId);
        setServicos(data);
      } catch (error) {
        console.error("Erro ao buscar serviços do barbeiro.", error);
      } finally {
        setLoading(false);
      }
    };
    fetchServicos();
  }, [userId]);

  const handleSelectServico = (servico) => {
    setServicoSelecionado(servico);
    setPasso(2);
  };

  const handleDateChange = async (e) => {
    const date = e.target.value;
    setDataSelecionada(date);
    setHorariosDisponiveis([]); // Limpa os horários antigos
    if (date && servicoSelecionado) {
      try {
        const horarios = await publicService.getDisponibilidade(userId, servicoSelecionado.id, date);
        setHorariosDisponiveis(horarios);
      } catch (error) {
        console.error("Erro ao buscar horários", error);
      }
    }
  };

  const handleConfirmarAgendamento = async (e) => {
    e.preventDefault();
    // Aqui virá a chamada para publicService.createAgendamento
    console.log("Agendamento a ser criado:", {
      userId,
      servicoSelecionado,
      horarioSelecionado,
      dadosCliente
    });
    setPasso(4); // Vai para a tela de sucesso
  };

  if (loading) return <p>Carregando informações do estúdio...</p>;

  return (
    <div className="booking-container">
      <div className="booking-card">
        {passo === 1 && (
          <div>
            <h2>Passo 1: Escolha o Serviço</h2>
            <div className="servicos-grid">
              {servicos.map(s => (
                <div key={s.id} className="servico-card" onClick={() => handleSelectServico(s)}>
                  <img src={s.imagem || 'https://via.placeholder.com/150'} alt={s.nome_servico} />
                  <h3>{s.nome_servico}</h3>
                  <p>R$ {s.preco} - {s.duracao_minutos} min</p>
                </div>
              ))}
            </div>
          </div>
        )}
        {passo === 2 && servicoSelecionado && (
          <div>
            <button className="back-button" onClick={() => setPasso(1)}>Voltar</button>
            <h2>Passo 2: Escolha a Data e Hora</h2>
            <p>Serviço: <strong>{servicoSelecionado.nome_servico}</strong></p>
            <input type="date" className="date-input" value={dataSelecionada} onChange={handleDateChange} />
            <div className="horarios-grid">
              {horariosDisponiveis.map((h, i) => (
                <button key={i} className="horario-button" onClick={() => { setHorarioSelecionado(h); setPasso(3); }}>
                  {new Date(h).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                </button>
              ))}
            </div>
          </div>
        )}

        {passo === 3 && horarioSelecionado && (
          <div>
            <button className="back-button" onClick={() => setPasso(2)}>Voltar</button>
            <h2>Passo 3: Confirme seus Dados</h2>
            <div className="resumo">
              <p><strong>Serviço:</strong> {servicoSelecionado.nome_servico}</p>
              <p><strong>Data:</strong> {new Date(horarioSelecionado).toLocaleDateString('pt-BR')}</p>
              <p><strong>Hora:</strong> {new Date(horarioSelecionado).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</p>
            </div>
            <form className="cliente-form" onSubmit={handleConfirmarAgendamento}>
              <input type="text" placeholder="Seu nome completo" required onChange={(e) => setDadosCliente({...dadosCliente, nome: e.target.value})} />
              <input type="tel" placeholder="Seu WhatsApp (XX) XXXXX-XXXX" required onChange={(e) => setDadosCliente({...dadosCliente, telefone: e.target.value})} />
              <button type="submit">Confirmar Agendamento</button>
            </form>
          </div>
        )}
        {passo === 4 && (
            <div>
                <h2>Agendamento Confirmado!</h2>
                <p>Obrigado, {dadosCliente.nome}! Você receberá uma confirmação no WhatsApp em breve.</p>
                <p>Seu horário para <strong>{servicoSelecionado.nome_servico}</strong> está marcado para <strong>{new Date(horarioSelecionado).toLocaleDateString('pt-BR')}</strong> às <strong>{new Date(horarioSelecionado).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</strong>.</p>
            </div>
        )}

      </div>
    </div>
  );
};

export default BookingPage;